import { Component, OnInit } from '@angular/core';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-cart-page',
  templateUrl: './cart-page.component.html',
  styleUrls: ['./cart-page.component.scss'],
})
export class CartPageComponent implements OnInit {
  reloadPage: string;
  cart: unknown;
  deviceType: any;

  constructor(private localStorageService: LocalStorageService,
    private tansactionService: TansactionService
  ) {
    this.deviceType = localStorageService.getItem('deviceType');
    this.reloadPage = this.localStorageService.getItem('reloadPage');
    if (this.reloadPage == 'true') {
      this.localStorageService.removeItem('reloadPage');
      window.location.reload();
    }
  }

  ngOnInit(): void {
    this.tansactionService
      .getCartDetails()
      .then((data) => {
        this.cart = data;
      })
      .catch((err) => {
        console.log(err);
      });
  }

  reloadCart() {
    this.tansactionService.getCartDetails().then(data => {
      this.cart = data;
    }).catch(err => {
      this.cart = null;
      console.log(err);
    })
  }
}
